<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.theme_content_group") }}
  .section-body(style="max-width:1000px;")
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-retweet"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getThemeContentGroupList()"
                  variant="primary"
                  size="sm"
                )
              //- .form-group.col-12
              //-   b-button(v-b-modal.addThemeContentGroup type="button" variant="info" size="sm")
              //-     i.fa.fa-plus
              //-     span.ml-1 {{ $t("ui.combine.add_theme_content_group") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.content_group')") {{ $t('ui.content_group') }}
                        th(width="8%")
                          span(:title="$t('ui.content_group_desc')") {{ $t('ui.content_group_desc') }}
                        //- th(width="5%")
                        //-   span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="themeContentGroupList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themeContentGroupList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.content_group") {{ item.content_group }}
                        td
                          span(:title="item.description") {{ item.description }}
                        //- td.actions.text-center.align-middle
                        //-   span.mr-2
                        //-     a.fa.fa-edit.text-primary.text-decoration-none(
                        //-       href="javascript:void(0)"
                        //-       @click="onEdit(item)"
                        //-       :title="$t('ui.edit')"
                        //-       )
                        //-   span
                        //-     a.fa.fa-trash.text-danger.text-decoration-none(
                        //-       href="javascript:void(0)"
                        //-       @click="onDelete(item)"
                        //-       :title="$t('ui.delete')"
                        //-       )

      //- addthemecontentgroup(@clicked="addThemeContentGroup" @failed="handleFailed")
      //- editthemecontentgroup(ref="editthemecontentgroup" :item="editSelectedThemeContentGroup" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
// import addthemecontentgroup from "@/components/content/themecontentgroup/addThemeContentGroup.vue";
// import editthemecontentgroup from "@/components/content/themecontentgroup/editThemeContentGroup.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    // addthemecontentgroup,
    // editthemecontentgroup
  },
  data: () => ({
    loading: false,
    // editSelectedThemeContentGroup: null,
    themeContentGroupList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {
    this.getThemeContentGroupList();
  },
  methods: {
    // onEdit(e) {
    //   this.editSelectedThemeContentGroup = e;
    //   this.$refs.editthemecontentgroup.$refs.editThemeContentGroup.show();
    // },
    // afterEdit() {
    //   this.getThemeContentGroupList();
    //   this.$helpers.showDialog(this.$t("ui.combine.edit_theme_content_group"), this.$t("message.success"), "success");
    // },
    // onDelete:function(e) {
    //   this.$helpers
    //     .alert({
    //       title: this.$t("ui.delete"),
    //       text: this.$t("message.delete_theme_content_group_confirm", { themecontentgroup: e.content_group }),
    //       type: "question",
    //       showCancelButton: true
    //     })
    //     .then(result => {
    //       if (result.value) {
    //         this.confirmDelete(e);
    //       }
    //     });
    // },
    // confirmDelete: function(e) {
    //   let url = config.deleteThemeContentGroupUrl();

    //   var json = {
    //     auth_token: this.$store.getters.sessionToken,
    //     action_by: this.$store.getters.loginId,
    //     content_group: e.content_group
    //   };

    //   this.feedback.success = true;
    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           if (typeof response.data.status == "string") {
    //             this.feedback.success = response.data.status == "1";
    //           } else {
    //             this.feedback.success = response.data.status == 1;
    //           }
    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             this.getThemeContentGroupList();
    //             this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function(response) {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    getThemeContentGroupList: function() {
      let url = config.getThemeContentGroupListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.themeContentGroupList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    // addThemeContentGroup: function() {
    //   this.getThemeContentGroupList();

    //   this.$helpers.showDialog(this.$t("ui.combine.add_theme_content_group"), this.$t("message.success"), "success");
    // },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>